/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:23:57
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import Card from '@/components/Common/Card';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'RechargesHistorySummary',

  props: ['subscriber', 'rechargesList'],

  components: { Card },

  computed: {
    rechargesAmount() {
      return this.rechargesList.data.length;
    },
    rechargesSum() {
      const rechargeAmounts = this.rechargesList.data.map(obj => Number(obj.amount));
      return rechargeAmounts.reduce((a, b) => +(a + b).toFixed(2), 0);
    },
    rechargesDateStart() {
      return `${this.rechargesList.terms.dateStart.slice(8, 10)}/${this.rechargesList.terms.dateStart.slice(5, 7)}/${this.rechargesList.terms.dateStart.slice(0, 4)}`;
    },
    rechargesDateEnd() {
      return `${this.rechargesList.terms.dateEnd.slice(8, 10)}/${this.rechargesList.terms.dateEnd.slice(5, 7)}/${this.rechargesList.terms.dateEnd.slice(0, 4)}`;
    },
  },
  methods: {
    openRechargesApp() {
      window.openRechargesApp();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Recharges/RechargesHistorySummary/component.js